// extracted by mini-css-extract-plugin
module.exports = {"outer":"outer___2QpC5","action":"action___Qs2ta"};